import { render, staticRenderFns } from "./DocumentFile.vue?vue&type=template&id=07ae1f5b&scoped=true"
import script from "./DocumentFile.vue?vue&type=script&lang=js"
export * from "./DocumentFile.vue?vue&type=script&lang=js"
import style0 from "./DocumentFile.vue?vue&type=style&index=0&id=07ae1f5b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07ae1f5b",
  null
  
)

export default component.exports